/**
 * Adding from the cart recommendations happens while the cart drawer is already
 * open, and the theme's drawer does
 *
 *   open(target) { new bootstrap.Offcanvas(target).show(); }
 *
 * on every render — a fresh instance each time, with no check for the drawer
 * already being shown. Bootstrap then appends a second backdrop over the first,
 * so the overlay gets darker with every add and each click only dismisses one
 * layer.
 *
 * Bootstrap fires `show.bs.offcanvas` before it builds the backdrop and honours
 * preventDefault, so refusing the redundant show keeps a single backdrop. The
 * drawer's contents are re-rendered by the theme either way.
 */
document.addEventListener(
  'show.bs.offcanvas',
  (event) => {
    const target = event.target;
    if (target instanceof Element && target.id === 'gsp-cart-drawer' && target.classList.contains('show')) {
      event.preventDefault();
    }
  },
  true
);

/**
 * Arrows for the cart recommendations rail. The rail is re-rendered by the
 * theme after every cart change, so the handlers are delegated from the
 * document and the state is recomputed from whatever is on the page now.
 */
(function () {
  function rails() {
    return Array.prototype.slice.call(document.querySelectorAll('.gsp-cart-rec__rail'));
  }

  function sync(rail) {
    var track = rail.querySelector('[data-cart-rec-track]');
    var prev = rail.querySelector('[data-cart-rec-prev]');
    var next = rail.querySelector('[data-cart-rec-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var overflows = max > 1;
    if (prev) {
      prev.hidden = !overflows;
      prev.disabled = track.scrollLeft <= 1;
    }
    if (next) {
      next.hidden = !overflows;
      next.disabled = track.scrollLeft >= max - 1;
    }
  }

  function syncAll() {
    rails().forEach(sync);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-rec-prev], [data-cart-rec-next]');
    if (!button) return;
    var rail = button.closest('.gsp-cart-rec__rail');
    var track = rail && rail.querySelector('[data-cart-rec-track]');
    if (!track) return;
    // Aim at a card's own offset rather than a pixel amount: the track snaps to
    // card edges, so a target that is already a snap point cannot be nudged
    // somewhere else on the way.
    var cards = Array.prototype.slice.call(track.querySelectorAll('.gsp-cart-rec__card'));
    if (!cards.length) return;
    var direction = button.hasAttribute('data-cart-rec-prev') ? -1 : 1;
    var current = 0;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].offsetLeft >= track.scrollLeft - 1) {
        current = i;
        break;
      }
    }
    var index = Math.min(Math.max(current + direction, 0), cards.length - 1);
    track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (track && track.hasAttribute && track.hasAttribute('data-cart-rec-track')) {
        sync(track.closest('.gsp-cart-rec__rail'));
      }
    },
    true
  );

  if (window.ResizeObserver) {
    var observer = new ResizeObserver(syncAll);
    var observed = new WeakSet();
    var watch = function () {
      rails().forEach(function (rail) {
        if (!observed.has(rail)) {
          observed.add(rail);
          observer.observe(rail);
        }
      });
      syncAll();
    };
    watch();
    new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', syncAll);
  }
})();
